<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-btn color="primary" @click="addClick">
                    <v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.add') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card flat outlined>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <TheTable
                                    :additional-filters="ranksTable.additionalFilters"
                                    :default-sort="ranksTable.defaultSort"
                                    :excel="true"
                                    :fields="ranksTable.headers"
                                    :header-selection-key="'ranks-headers'"
                                    :filter-save-key="'ranks-filters'"
                                    :height="ranksTable.height"
                                    :total-records="ranksTable.total"
                                    @excel="excelExport"
                                    @headers="selectHeaders"
                                    @reload="reloadData"
                                >
                                    <tr
                                        v-for="(item, key) in ranksTable.items"
                                        :key="key"
                                        :class="{'cursor-pointer': true}"
                                        @contextmenu.prevent="editClick(props.item.id, true)"
                                    >
                                        <td
                                            v-if="ranksTable.selectedHeaders.includes('name')"
                                            class="font-weight-bold"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.name }}
                                        </td>
                                        <td
                                            v-if="ranksTable.selectedHeaders.includes('abbreviation')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.abbreviation }}
                                        </td>
                                        <td
                                            v-if="ranksTable.selectedHeaders.includes('rank_category_id')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.rank_category_display }}
                                        </td>
                                        <td
                                            v-if="ranksTable.selectedHeaders.includes('active')"
                                            @click="editClick(item.id, false)"
                                        >
                                            <v-icon v-if="item.active" small>fa-check</v-icon>
                                        </td>
                                        <td>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-btn
                                                        icon
                                                        v-bind="attrs"
                                                        @click="editClick(item.id, true)"
                                                        v-on="on"
                                                    >
                                                        <v-icon small>fa-external-link-alt</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ $t('tooltips.openInNewTab') }}</span>
                                            </v-tooltip>
                                        </td>
                                    </tr>
                                </TheTable>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import TheTable from './trinkets/TheTable';

export default {
    name: 'Ranks',
    components: {TheTable},
    data: function () {
        return {
            ranksTable: {
                selectedHeaders: [],
                headers: [
                    {text: this.$t('fields.name'), value: 'name', type: 'string', allowFilter: true},
                    {text: this.$t('fields.abbreviation'), value: 'abbreviation', type: 'string', allowFilter: true},
                    {
                        text: this.$t('fields.category'),
                        value: 'rank_category_id',
                        type: 'dropdown|rank-categories',
                        width: '150px',
                        allowFilter: true,
                    },
                    {
                        text: this.$t('fields.active'),
                        value: 'active',
                        type: 'boolean',
                        default: null,
                        width: '150px',
                        allowFilter: true,
                    },
                    {text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false},
                ],
                additionalFilters: [],
                items: [],
                total: 0,
                lastRequest: null,
                height: '0px',
                defaultSort: {
                    field: 'name',
                    descending: true,
                },
            },
        };
    },
    methods: {
        addClick() {
            this.$router.push('/ranks/0');
        },
        editClick(id, newTab = false) {
            if (!newTab) {
                this.$router.push('/ranks/' + id);
            } else {
                let routeData = this.$router.resolve('/ranks/' + id);
                window.open(routeData.href, '_blank');
            }
        },
        selectHeaders(headers) {
            this.ranksTable.selectedHeaders = headers;
        },
        reloadData(request) {
            this.lastRequest = request;
            let vm = this;
            this.$APICall('get', 'ranks', request, (data, success) => {
                if (success) {
                    vm.ranksTable.items = data.items;
                    vm.ranksTable.total = data.total;
                } else {
                    vm.$alert(vm.$t('alerts.basicError'));
                }
            });
        },
        excelExport() {
            let excelRequest = JSON.parse(JSON.stringify(this.lastRequest));
            excelRequest.pagination.itemsPerPage = 999999999;
            excelRequest.pagination.page = 1;

            let vm = this;
            this.$APICall(
                'get',
                'ranks',
                excelRequest,
                (data, success) => {
                    if (success) {
                        vm.$APICall('post', 'excel/ranks', data.items, (data) => {
                            window.open(data.link);
                        });
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
        resolveWindowResize() {
            this.ranksTable.height = window.innerHeight - 310 + 'px';
        },
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        this.$myStore.commit('setBreadcrumbs', [{text: this.$t('modules.ranks'), href: '/#/ranks', disabled: true}]);

        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
    },
};
</script>

<style scoped></style>
